module.exports = __webpack_public_path__ + "img/2.4d12d4f1.png";